import React from "react";

const TutoringListSkeleton = ({ totalItem = 1 }) => {
  const skeletonItems = Array.from({ length: totalItem }, (_, index) => (
    <div key={index} className="flex border border-gray-200 rounded-lg p-4">
      <div className="flex flex-col flex-auto gap-4">
        <div className="h-32 bg-gray-200 rounded-md" />
        <div className="flex gap-2">
          <div className="w-20 h-5 bg-gray-200 rounded-full" />
          <div className="w-20 h-5 bg-gray-200 rounded-full" />
        </div>
        <div className="flex flex-col gap-1">
          <div>
            <div className="h-4 bg-gray-200 rounded" />
          </div>
          <div>
            <div className="h-4 bg-gray-200 rounded" />
          </div>
        </div>
        <div className="h-4 w-1/2 bg-gray-200 rounded" />
        <div className="flex border border-gray-300 rounded-lg gap-2 p-2 items-center">
          <div className="w-9 h-9 bg-gray-200 rounded-full" />
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded" />
            <div className="h-4 bg-gray-200 rounded mt-1" />
          </div>
        </div>
        <div className="flex justify-between">
          <div className="w-20 h-5 bg-gray-200 rounded" />
          <div className="w-20 h-5 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  ));

  return (
    <div className="grid animate-pulse grid-cols-1 sm:grid-cols-2 sm:mx-0 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {skeletonItems}
    </div>
  );
};

export default TutoringListSkeleton;
